import React from "react";
import { Spin } from "antd";
import useIsMobileWithWidth from "~utils/media-breakpoint";
import "./index.less";

export const Buttons = ({
  className,
  showSpinner,
  style,
  icon,
  iconFill,
  callParentFunction,
  isDisabled,
  text,
  noMobile
}: any) => {
  const isMobile = useIsMobileWithWidth("(max-width: 980px)");

  return (
    <>
      <button
        //   type={type ? type : "submit"}
        className={className || "button"}
        style={icon ? {...style, display: 'flex', alignItems: 'center', gap: '5px', padding: '0 25px', } : style}
        onClick={() => callParentFunction && callParentFunction()}
        disabled={isDisabled}
      >
        {showSpinner && <Spin style={{marginRight: '10px', display: 'flex'}} size="small"/>}

        {isMobile && !noMobile && icon ? '' : text}

        {/* This exists for SVG icons with color */}
        {icon && (
          typeof icon === "string"
            ? <img src={icon} style={{ width: '20px', ...(!isMobile && { marginLeft: '15px' }) }}/>
            : <span style={{ display: 'flex', ...(!isMobile && { marginLeft: '15px' }) }}>
                {React.createElement(icon, { size: "20", fill: iconFill || "currentColor" })}
              </span>
        )}
      </button>
    </>
  );
};
